module.exports = __webpack_public_path__ + "img/testimonials-1.828e0935.jpg";